import { render } from "./SearchCreateMatchResultsView.vue?vue&type=template&id=5c2bbf01&scoped=true"
import script from "./SearchCreateMatchResultsView.vue?vue&type=script&lang=js"
export * from "./SearchCreateMatchResultsView.vue?vue&type=script&lang=js"

import "./SearchCreateMatchResultsView.vue?vue&type=style&index=0&id=5c2bbf01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2bbf01"]])

export default __exports__